import { useSite } from "@/context/SiteContext";
import Navbar from "./Navbar";
import Hero from "./Hero";
import About from "./About";
import WhyChoose from "./WhyChoose";
import Courses from "./Courses";
import Faculty from "./Faculty";
import Gallery from "./Gallery";
import Testimonials from "./Testimonials";
import Events from "./Events";
import Admission from "./Admission";
import Contact from "./Contact";
import Footer from "./Footer";
import BannerSlider from "./BannerSlider";
import CustomSection from "./CustomSection";
import Popup from "./Popup";

export default function PublicSite() {
  const data = useSite();
  const site = data?.site;

  if (data?.loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-[var(--c-bg)]">
        <div className="font-heading text-3xl text-[var(--c-primary)] animate-pulse">শ্রুতি</div>
      </div>
    );
  }

  const renderers = {
    hero: () => <Hero site={site} />,
    about: () => <About site={site} />,
    why: () => <WhyChoose site={site} />,
    courses: () => <Courses site={site} courses={data?.courses} />,
    faculty: () => <Faculty site={site} faculty={data?.faculty} />,
    gallery: () => <Gallery site={site} gallery={data?.gallery} />,
    testimonials: () => <Testimonials site={site} testimonials={data?.testimonials} />,
    events: () => <Events site={site} events={data?.events} />,
    admission: () => <Admission site={site} courses={data?.courses} />,
    contact: () => <Contact site={site} />,
  };

  const defaultOrder = ["hero", "about", "why", "courses", "faculty", "gallery", "testimonials", "events", "admission", "contact"];
  const sections = (site?.sections && site.sections.length ? site.sections : defaultOrder.map((k) => ({ id: k, key: k, enabled: true })))
    .filter((s) => s.enabled !== false);

  return (
    <div className="min-h-screen bg-[var(--c-bg)]">
      <Navbar site={site} />
      <BannerSlider banners={data?.banners} />
      <main>
        {sections.map((s) => {
          if (s.key === "custom") return <CustomSection key={s.id} section={s} />;
          const r = renderers[s.key];
          return r ? <div key={s.id}>{r()}</div> : null;
        })}
      </main>
      <Footer site={site} />
      <Popup popups={data?.popups} />
    </div>
  );
}
